import { useState, useEffect } from "react";

import { cn } from "tools/ui";
import { useStoreRest } from "../storeRest";
import Button from "componentsv2/button/Button";
import date from "date-and-time";
import dates from "tools/dates";

import proxy from "api/proxy";
import TableStats from "./TableStats";
import TableCard from "./TableCard";

function TableView({
  defaultShop,
  onChangeView,
  selectTable = false,
  tableSelected,
}) {
  const tables =
    useStoreRest((state) => state.shops[defaultShop]?.tables) || [];
  const [selectedZones, setSelectedZones] = useState([]);
  const [salesByTable, setSalesByTable] = useState({});
  const [filterType, setFilterType] = useState("total");

  // TEMP: consulta de selecciones para verificar campos
  // useEffect(() => {
  //   (async () => {
  //     const { data: a } = await proxy.getFields("sale.sale", []);
  //     const { data: b } = await proxy.getFields(
  //       "account.invoice.payment_term",
  //       ["payment_type"],
  //     );
  //     console.log("invoice_state selection", a?.invoice_state?.selection);
  //     console.log("payment_type selection", b?.payment_type?.selection);
  //   })();
  // }, []);

  const zones = tables.reduce((acc, table) => {
    const zone = table["zone."]?.name;
    if (!acc[zone]) {
      acc[zone] = [];
    }
    acc[zone].push(table);
    return acc;
  }, {});

  const zoneNames = Object.keys(zones).length > 1 ? Object.keys(zones) : [];

  function toggleZone(zone) {
    setSelectedZones((prev) =>
      prev.includes(zone) ? prev.filter((z) => z !== zone) : [...prev, zone],
    );
  }

  const zoneFilteredTables =
    selectedZones.length === 0
      ? tables
      : tables.filter((table) => selectedZones.includes(table["zone."]?.name));

  const typeFilteredTables = zoneFilteredTables.filter((table) => {
    switch (filterType) {
      case "available":
        return !salesByTable[table.id]?.length;
      case "active":
        return salesByTable[table.id]?.length > 0;
      case "reservation":
        return salesByTable[table.id]?.some((sale) => sale.is_reservation);
      default:
        return true; // all
    }
  });

  const stats = {
    total: zoneFilteredTables.length,
    available: zoneFilteredTables.filter((t) => !salesByTable[t.id]?.length)
      .length,
    active: zoneFilteredTables.filter((t) => salesByTable[t.id]?.length > 0)
      .length,
    reservation: zoneFilteredTables.filter(
      (t) => t.state === "reserved", // Ajustar
    ).length,
  };

  async function getSales() {
    const tableIds = zoneFilteredTables.map((table) => table.id);
    if (tableIds.length === 0) return;

    const last24h = dates.fmtDatetime2Tryton(date.addHours(new Date(), -24));

    const { data } = await proxy.search(
      "sale.sale",
      [
        ["state", "=", "draft"],
        ["table_assigned", "in", tableIds],
        ["create_date", ">=", last24h],
        [
          "OR",
          ["invoices", "=", null],
          ["payment_term.payment_type", "!=", 2],
        ],
      ],
      [
        "agent.rec_name",
        "persons",
        "create_date",
        "table_assigned",
        "number",
        "position",
      ],
    );

    const grouped = {};
    data.forEach((sale) => {
      const tableId = sale.table_assigned;
      if (!grouped[tableId]) grouped[tableId] = [];
      grouped[tableId].push(sale);
    });

    setSalesByTable(grouped);
  }

  function onNewSale(table) {
    onChangeView(null, "add", { table_assigned: table });
  }

  function onEditSale(sale) {
    onChangeView(null, "edit", sale);
  }

  useEffect(() => {
    getSales();
  }, [selectedZones, tables]);

  let styleTables = "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4";
  if (selectTable) {
    styleTables = "grid grid-cols-2 md:grid-cols-3 gap-4";
  }

  return (
    <>
      <TableStats
        stats={stats}
        onFilter={(type) => setFilterType(type)}
        activeFilter={filterType}
      />
      <div className="space-y-4 rounded-lg bg-white p-4">
        <div className="flex flex-wrap gap-2 items-center">
          {zoneNames.length > 1 && (
            <span className="text-sm text-zinc-700 ">ZONAS:</span>
          )}
          {zoneNames.map((zone) => {
            const isActive = selectedZones.includes(zone);
            return (
              <Button
                key={zone}
                name={zone}
                onClick={() => toggleZone(zone)}
                style={cn(
                  "px-4 py-1 rounded-lg border transition !w-32 !md:w-40",
                  isActive
                    ? "bg-amber-300 border-amber-300 text-gray-900"
                    : "bg-white border-gray-300 text-gray-700 hover:bg-gray-100",
                )}
              >
                {zone}
              </Button>
            );
          })}
        </div>

        <div className={styleTables}>
          {typeFilteredTables.map((table) => {
            const sales = salesByTable[table.id] || [];
            const isSelected = tableSelected?.value?.id === table.id;
            return (
              <TableCard
                key={table.id}
                table={table}
                sales={sales}
                selectTable={selectTable}
                onNewSale={onNewSale}
                onEditSale={onEditSale}
                isSelected={isSelected}
                onSelect={(table) => {
                  tableSelected.value = table;
                }}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}

export default TableView;
